import React from 'react';
import { ProcessingTypeEnum } from '../inputs/ProcessingTypeSelectFormik';
import FrameSelectFormik from '../inputs/FrameSelectFormik';
import DegreeTypeSelectFormik from '../inputs/DegreeTypeSelectFormik';
import ProcessingTypeSelectFormik from '../inputs/ProcessingTypeSelectFormik';
import TextField from '@material-ui/core/TextField';
import { FormControl, FormLabel, InputLabel, TableCell, TableRow } from '@material-ui/core';
import { Field } from 'formik';
import { useTranslation } from 'react-i18next';

interface Props {
  values: any;
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
  classes: any;
}

const ProcessingInputField: React.FC<Props> = ({ values, setFieldValue, classes }) => {
  const {t} = useTranslation();

  return (
      <TableRow>
        <TableCell align='left' className={classes.tableCellSpacing}>
          <FormControl margin="normal" className={classes.formControl}>
            <InputLabel id='processingType'>{t('processing')}</InputLabel>
            <ProcessingTypeSelectFormik
              processingType={values.processingType}
              meganetFrameMasterId={values.meganetFrameMasterId}
              name='processingType'
              onChange={processingType => {
                setFieldValue('processingType', processingType);
              }}
            />
          </FormControl>
        </TableCell>
        {(values.processingType === ProcessingTypeEnum.Maker &&
          <>
            <TableCell align='left' className={classes.tableCellSpacing}>
              <FormControl margin="normal" className={classes.formControl}>
                <FormLabel id='meganetFrameMasterId' style={{ fontSize: 13, }}>{t('frame')}</FormLabel>
                <br />
                <FrameSelectFormik
                  meganetFrameMasterId={values.meganetFrameMasterId} 
                  onChange={meganetFrameMasterId => {
                    setFieldValue('meganetFrameMasterId', meganetFrameMasterId);
                  }}
                />
              </FormControl>
            </TableCell>
            <TableCell align='left' className={classes.tableCellSpacing}>
              <FormControl margin="normal" className={classes.formControl}>
                <FormLabel id='degreeType' style={{ fontSize: 13, }}>{t('degreeType')}</FormLabel>
                <br />
                <DegreeTypeSelectFormik
                  degreeType={values.degreeType}
                  onChange={degreeType => {
                    setFieldValue('degreeType', degreeType);
                  }}
                />
              </FormControl>
            </TableCell>
            <TableCell align='right' className={classes.tableCellSpacing}>
              <Field margin="normal" fullWidth name='leftPd' label={`${t('left')} ${t('pd')}`} type='number' id='leftPd' component={TextField}
                value={values.leftPd}
                onChange={(event: any) => {
                  setFieldValue("leftPd", event.target.value);
                }}
              />
            </TableCell>
            <TableCell align='left' className={classes.tableCellSpacing}>
              {values.degreeType === 2 || values.degreeType === 0 ? // 2:遠用 0:近用
                <>
                  <FormLabel id='leftHeight' style={{ fontSize: 13, }}>{`${t('left')} ${t('ep')}`}</FormLabel>
                  <br />
                  <FormLabel id='leftHeight' style={{ color: 'black' }}>{values.degreeType === 2 ? 2 : 0 }</FormLabel>
                </> :
                <Field margin="normal" fullWidth name='leftHeight' label={`${t('left')} ${t('ep')}`} type='number' id='leftHeight' component={TextField} 
                  value={values.leftHeight}
                  onChange={(event: any) => {
                    setFieldValue("leftHeight", event.target.value);
                  }}
                />
              }
            </TableCell>
            <TableCell align='right' className={classes.tableCellSpacing}>
              <Field margin="normal" fullWidth name='rightPd' label={`${t('right')} ${t('pd')}`} type='number' id='rightPd' component={TextField} 
                value={values.rightPd}
                onChange={(event: any) => {
                  setFieldValue("rightPd", event.target.value);
                }}
              />
            </TableCell>
            <TableCell align='left' className={classes.tableCellSpacing}>
              {values.degreeType === 2 || values.degreeType === 0 ? // 2:遠用 0:近用
                <>
                  <FormLabel id='rightHeight' style={{ fontSize: 13, }}>{`${t('right')} ${t('ep')}`}</FormLabel>
                  <br />
                  <FormLabel id='rightHeight' style={{ color: 'black' }}>{values.degreeType === 2 ? 2 : 0 }</FormLabel>
                </> :
                <Field margin="normal" fullWidth name='rightHeight' label={`${t('right')} ${t('ep')}`} type='number' id='rightHeight' component={TextField}
                  value={values.rightHeight}
                  onChange={(event: any) => {
                    setFieldValue("rightHeight", event.target.value);
                  }}
                />
              }
            </TableCell>
          </>
        )}
    </TableRow>
  );
}

export default ProcessingInputField;
